import { Vector3 } from '../Maths/math';
/**
 * @hidden
 */
var _MeshCollisionData = /** @class */ (function () {
    function _MeshCollisionData() {
        this._checkCollisions = false;
        this._collisionMask = -1;
        this._collisionGroup = -1;
        this._collider = null;
        this._oldPositionForCollisions = new Vector3(0, 0, 0);
        this._diffPositionForCollisions = new Vector3(0, 0, 0);
    }
    return _MeshCollisionData;
}());
export { _MeshCollisionData };
//# sourceMappingURL=meshCollisionData.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Collisions/meshCollisionData.js
// module id = Kyih
// module chunks = 0